module.exports = __webpack_public_path__ + "assets/g-drive-logo.841b11fb.svg";